export var COLLECT_PAGE_TITLE = "Recibir Pago";
export var COLLECT_PAGE_TITLE_COMPLETED = "Resumen de pagos";
export var COLLECT_COMPLETED_STATUS = "COMPLETED";
export var COLLECT_PAGE_SUBTITLE_PREFIX = "Carga de cobranza";
export var COLLECT_BACK_BUTTON_LABEL = "Anterior";
export var COLLECT_UPLOAD_BUTTON_LABEL = "Cargar archivos";
export var COLLECT_PROCESS_BUTTON_LABEL = "Procesar cobros";
export var COLLECT_REVIEW_TRIGGER_LABEL = "Ver resumen de la carga";
export var COLLECT_REVIEW_MODAL_TITLE = "Confirmar cobranza";
export var COLLECT_CANCEL_LABEL = "Cancelar";
export var COLLECT_CONFIRM_MODAL_TITLE = "Confirmar el cobro";
export var COLLECT_CONFIRM_MODAL_MESSAGE = "Esta acción procesará los pagos de esta cobranza y no se puede deshacer.";
export var COLLECT_CONFIRM_MODAL_SUBMIT_LABEL = "Sí, procesar";
export var COLLECT_VALIDATION_MODAL_TITLE = "Resultado de validación";
export var COLLECT_VALIDATION_SUCCESS_LABEL = "success";
export var COLLECT_VALIDATION_ERROR_LABEL = "error";
export var COLLECT_VALIDATION_CATALOG_LABEL = "Catálogo";
export var COLLECT_VALIDATION_CODE_LABEL = "Código";
export var COLLECT_VALIDATION_VERSION_LABEL = "Versión";
export var COLLECT_VALIDATION_FILES_LABEL = "Archivos procesados";
export var COLLECT_VALIDATION_TOTALS_LABEL = "Totales";
export var COLLECT_VALIDATION_TOTAL_ROWS_LABEL = "Total filas";
export var COLLECT_VALIDATION_TOTAL_POLICIES_LABEL = "Total pólizas";
export var COLLECT_VALIDATION_UNKNOWN_ROWS_LABEL = "Filas con código desconocido";
export var COLLECT_VALIDATION_MISSING_POLICIES_LABEL = "Pólizas no encontradas";
export var COLLECT_VALIDATION_UNKNOWN_CODES_PREFIX = "Códigos desconocidos";
export var COLLECT_VALIDATION_MISSING_CODES_PREFIX = "Pólizas no localizadas";
export var buildCollectValidationBreakdownLabel = function (count) {
    return "Desglose por c\u00F3digo (".concat(count, ")");
};
export var COLLECT_VALIDATION_TABLE_CODE_LABEL = "Código";
export var COLLECT_VALIDATION_TABLE_LABEL_LABEL = "Etiqueta";
export var COLLECT_VALIDATION_TABLE_TRANSACTION_LABEL = "Transacción";
export var COLLECT_VALIDATION_TABLE_DESCRIPTION_LABEL = "Descripción";
export var COLLECT_VALIDATION_TABLE_ACTION_LABEL = "Acción";
export var COLLECT_VALIDATION_TABLE_ACTION_DETAIL_LABEL = "Detalle de acción";
export var COLLECT_VALIDATION_TABLE_IN_CATALOG_LABEL = "En catálogo";
export var COLLECT_VALIDATION_TABLE_POLICIES_LABEL = "Pólizas";
export var COLLECT_VALIDATION_TABLE_ROWS_LABEL = "Filas";
export var COLLECT_VALIDATION_EMPTY_CODE_LABEL = "Sin código";
export var COLLECT_TRANSACTION_LABELS = {
    DEBIT: "Débito",
    REJECTED: "Rechazado",
    CANCELLED: "Cancelado",
};
export var getCollectTransactionLabel = function (transaction) { var _a; return (_a = COLLECT_TRANSACTION_LABELS[transaction]) !== null && _a !== void 0 ? _a : transaction; };
export var COLLECT_VALIDATION_FILE_ROWS_SUFFIX = "filas";
export var COLLECT_DEFAULT_COLLECTION_OPTION = "Cobranza mensual normal";
export var COLLECT_NO_VALUE_LABEL = "—";
export var COLLECT_INFO_PANEL_TITLE = "Resumen de cobranza";
export var COLLECT_DETAIL_GROUP_LABEL = "Detalle";
export var COLLECT_SUMMARY_GROUP_LABEL = "Resumen de cobro";
export var COLLECT_PARAMETERS_GROUP_LABEL = "Parámetros";
export var COLLECT_RULES_GROUP_LABEL = "Reglas activas de Generar Cobros";
export var COLLECT_USER_LABEL = "Usuario";
export var COLLECT_CREATED_AT_LABEL = "Fecha de creación";
export var COLLECT_COLLECTION_OPTION_LABEL = "Opción de cobro";
export var COLLECT_BATCH_NUMBER_LABEL = "Número de lote";
export var COLLECT_PERIOD_LABEL = "Período";
export var COLLECT_PRODUCTS_LABEL = "Productos";
export var COLLECT_MAX_PERIODS_LABEL = "Períodos máximos";
export var COLLECT_UPLOAD_STEP_TITLE = "1. Cargar archivos";
export var COLLECT_UPLOAD_DROPZONE_LABEL = "Arrastrá y soltá tus archivos aquí";
export var COLLECT_UPLOAD_PICK_LABEL = "Desde el dispositivo";
export var COLLECT_UPLOAD_COUNT_LABEL = "Archivos seleccionados";
export var COLLECT_UPLOAD_EMPTY_TITLE = "Aún no has seleccionado archivos";
export var COLLECT_UPLOAD_EMPTY_SUBTITLE = "Arrastrá archivos o seleccioná desde tu dispositivo";
export var COLLECT_UPLOAD_ACCEPT = [".xlsx", ".xls", ".csv"];
export var COLLECT_UPLOAD_ACCEPT_ATTR = COLLECT_UPLOAD_ACCEPT.join(",");
export var COLLECT_MAX_FILE_SIZE_MB = 25;
export var COLLECT_EXTENSION_MESSAGE = "Solo se aceptan archivos ".concat(COLLECT_UPLOAD_ACCEPT.join(", "));
export var COLLECT_FILE_SIZE_MESSAGE = "Cada archivo debe pesar menos de ".concat(COLLECT_MAX_FILE_SIZE_MB, " MB");
export var buildCollectUploadHint = function (maxFiles) {
    return "Formatos permitidos: ".concat(COLLECT_UPLOAD_ACCEPT.join(", "), " \u00B7 M\u00E1x. ").concat(maxFiles, " ").concat(maxFiles === 1 ? "archivo" : "archivos", " \u00B7 M\u00E1x. ").concat(COLLECT_MAX_FILE_SIZE_MB, " MB por archivo");
};
export var buildCollectMaxFilesMessage = function (maxFiles) {
    return "Solo pod\u00E9s cargar hasta ".concat(maxFiles, " ").concat(maxFiles === 1 ? "archivo" : "archivos");
};
export var COLLECT_EXISTING_FILES_LABEL = "Archivo generado para la cobranza";
export var COLLECT_RESULTS_STEP_TITLE = "2. Resultado de la Cobranza";
export var COLLECT_RESULTS_SUMMARY_LABEL = "Resumen general";
export var COLLECT_RESULTS_REVIEW_LABEL = "Requieren revisión";
export var COLLECT_NO_FILES_SELECTED_MESSAGE = "Selecciona al menos un archivo para cargar";
export var COLLECT_UPLOAD_SUCCESS_MESSAGE = "Archivos subidos correctamente";
export var COLLECT_GENERIC_ERROR_MESSAGE = "Hubo inconvenientes al procesar la solicitud, por favor contacte con la aseguradora";
export var COLLECT_UPLOAD_FAILED_MESSAGE = "No se pudieron subir todos los archivos. Revisá los marcados con error e intentá de nuevo";
export var COLLECT_UPLOAD_LINK_EXPIRED_MESSAGE = "El enlace de carga venció. Volvé a intentarlo";
export var COLLECT_DEFAULT_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export var COLLECT_EXPIRED_LINK_STATUS = 403;
export var COLLECT_PROCESSING_STATUS = "PROCESSING_BANK_FILE";
export var COLLECT_POLL_INTERVAL_MS = 10000;
export var COLLECT_POLL_MAX_DURATION_MS = 10 * 60 * 1000;
